import cookie from "react-cookies";

export function isCandidateLoggedIn() {
  return !!cookie.load("candidateKey");
}

export function getCandidateDisplayName() {
  return cookie.load("candidateName") || null;
}

/** Short creator display id, e.g. CDSFSDE0 (first 8 of candidate UUID). */
export function shortCandidateId(candidateid) {
  if (!candidateid) return "";
  return String(candidateid).slice(0, 8).toUpperCase();
}

/** Breadcrumb label, e.g. Creator(CDSFSDE0). Falls back to Creator. */
export function formatCreatorBreadcrumbLabel(candidateid) {
  const short = shortCandidateId(candidateid);
  return short ? `Creator(${short})` : "Creator";
}

function candidateIdFromToken(token) {
  if (!token || typeof token !== "string") return "";
  try {
    const payload = token.split(".")[1];
    if (!payload) return "";
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = JSON.parse(atob(normalized));
    return json?.candidateid || json?.candidateId || "";
  } catch {
    return "";
  }
}

export function getCandidateId() {
  return (
    cookie.load("candidateId") ||
    candidateIdFromToken(cookie.load("candidateKey")) ||
    ""
  );
}

/** Clear candidate session cookies and legacy localStorage keys. */
export function clearCandidateSession() {
  cookie.remove("candidateKey", { path: "/" });
  cookie.remove("candidate-qt", { path: "/" });
  cookie.remove("candidate-qt-c", { path: "/" });
  cookie.remove("candidateName", { path: "/" });
  cookie.remove("candidateId", { path: "/" });
  localStorage.removeItem("authToken");
  localStorage.removeItem("userEmail");
}

/**
 * Sign out and optionally redirect.
 * @param {{ redirectTo?: string | null }} options - null = no redirect (stay on page)
 */
export function signOutCandidate({ redirectTo = "/login" } = {}) {
  if (!isCandidateLoggedIn()) return;
  clearCandidateSession();
  if (redirectTo == null) return;
  window.location.href = redirectTo;
}
